// /components/ImageSlider.jsx

import React from "react";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { getStaticFileUrl } from "../utils/config";

const placeholderStyle = {
  width: "100%",
  aspectRatio: "4 / 3",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

/**
 * 이미지 슬라이더 (최소 6개씩 null placeholder)
 *
 * @param {Object} props
 *  - imageSlides: 2차원 배열 [[item|null, item|null, ...], ...]
 *  - slideIndex: 현재 슬라이드 인덱스
 *  - onPrevSlide: () => void
 *  - onNextSlide: () => void
 *  - isLeftDisabled: boolean
 *  - isRightDisabled: boolean
 */
const ImageSlider = ({
  imageSlides,
  slideIndex,
  onPrevSlide,
  onNextSlide,
  isLeftDisabled,
  isRightDisabled,
}) => {
  const currentSlide = imageSlides[slideIndex] || [];

  return (
    <>
      <Box
        sx={{
          marginTop: "20px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          minHeight: "200px",
          maxHeight: "600px",
          overflow: "hidden",
          px: { xs: 2, md: 0 },
        }}
      >
        {currentSlide.length > 0 && (
          <Grid
            container
            spacing={{ xs: 1, md: 2 }}
            justifyContent="center"
            sx={{ maxWidth: "1200px" }}
          >
            {currentSlide.map((item, idx) => {
              if (!item) {
                return (
                  <Grid item xs={6} sm={6} md={4} key={idx}>
                    <Box sx={placeholderStyle}>
                    </Box>
                  </Grid>
                );
              }

              // item이 { src, subTab } 형태거나 단순 string(url)
              const src = item.src || item;

              return (
                <Grid item xs={6} sm={6} md={4} key={idx}>
                  <Box
                    sx={{
                      position: "relative",
                      width: "100%",
                      aspectRatio: "4 / 3",
                      backgroundColor: "#f0f0f0",
                      backgroundImage: `url(${getStaticFileUrl(src)})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      overflow: "hidden",
                    }}
                  />
                </Grid>
              );
            })}
          </Grid>
        )}
      </Box>

      <Box
        sx={{
          width: "90vw",
          maxWidth: "1175px",
          display: "flex",
          justifyContent: "flex-end",
          gap: "12px",
          paddingTop: "16px",
          paddingBottom: "36px",
        }}
      >
        <IconButton
          onClick={onPrevSlide}
          disabled={isLeftDisabled}
          sx={{
            backgroundColor: "white",
            color: `${isLeftDisabled ? "gray" : "red"} !important`,
            border: `2px solid ${isLeftDisabled ? "gray" : "red"} !important`,
            borderRadius: "50%",
            "&.Mui-disabled": {
              opacity: 0.5,
            },
            width: { xs: "32px", md: "40px" },
            height: { xs: "32px", md: "40px" },
          }}
        >
          <KeyboardArrowLeftIcon
            sx={{
              fontSize: { xs: "32px", md: "36px" },
              color: "inherit",
            }}
          />
        </IconButton>

        <IconButton
          onClick={onNextSlide}
          disabled={isRightDisabled}
          sx={{
            backgroundColor: "white",
            color: `${isRightDisabled ? "gray" : "red"} !important`,
            border: `2px solid ${isRightDisabled ? "gray" : "red"} !important`,
            borderRadius: "50%",
            "&.Mui-disabled": {
              opacity: 0.5,
            },
            width: { xs: "32px", md: "40px" },
            height: { xs: "32px", md: "40px" },
          }}
        >
          <KeyboardArrowRightIcon
            sx={{
              fontSize: { xs: "32px", md: "36px" },
              color: "inherit",
            }}
          />
        </IconButton>
      </Box>
    </>
  );
};

export default ImageSlider;
